export * from './app-footer.component';



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-footer/index.ts